/*global jQuery:false */

(function ($) {
        $.fn.changeAddress = function () {
            var init = function () {
                $(document).on('click', '.formActive__edit-link--ajax', function () {
                    if (isInCheckoutPage()) {
                        handleCheckoutButtonState(true);
                    }
                    let $trigger = $(this);
                    let $container = $trigger.closest('.formActive');
                    showEditForm($container, $trigger);
                });
            };

            function showEditForm($container, $trigger) {
                let urlToGet = buildFormUrl($container, $trigger);
                let $contentToReplace = $container.find('.accordion-content-target');
                TINK.inProgress($contentToReplace);

                TINK.sessionAjax({
                    url: urlToGet,
                    type: 'get',
                    success: function (response) {
                        $contentToReplace.empty().append(response);
                        TINK.stopProgress($contentToReplace);
                        CANADA_POST.bind($container, true);
                        formActive.editLink($trigger);
                        submitForm($container);
                    },
                    error: function (jqXHR) {
                        TINK.redirectIfConflict(jqXHR);
                    }
                });
            }

            function submitForm($container) {
                var $addressForm = $container.find('form.address-form');

                $addressForm.on('submit', function (e) {
                    let $container = $(this).closest('.formActive');
                    e.preventDefault();
                    TINK.inProgress($container);
                    saveForm($container, $addressForm);
                    if (isInCheckoutPage()) {
                        handleCheckoutButtonState(false);
                    }
                });
                $addressForm.formDetectOnchange();
            }

            function saveForm($container, $addressForm) {
                TINK.sessionAjax({
                    url: $addressForm.attr('action'),
                    type: $addressForm.attr('method'),
                    data: $addressForm.serializeArray(),
                    success: function (data) {
                        if ($container.attr('data-create') === 'new-address') {
                            if (isFormInError(data)) {
                                $container.find('.accordion-content-target').html(data);
                                CANADA_POST.bind($container, true);
                                $('.has--error input').first().focus();
                                submitForm($container);
                            } else {
                                let containerId = `${$(data).filter('[id]').first().attr('id')}-container`;
                                addNewAddressIn(containerId, data);
                                var $containerId = $(`#${containerId}`);
                                formActive.$formActive = $containerId;
                                if (typeof inBuyerPreferences !== undefined) {
                                    refreshAddresses();
                                    formActive.$formRequested = null;
                                    formActive.init();
                                }
                            }
                        } else {
                            if (isFormInError(data)) {
                                $container.find('.accordion-content-target').html(data);
                                var $linkInternal = $container.find('[data-module~="link-internal"]');
                                if ($linkInternal.length) {
                                    var positionModifier = typeof linkInternalPositionModifier !== 'undefined' ? linkInternalPositionModifier : '';
                                    $linkInternal.link_internal({
                                        positionModifier: positionModifier,
                                        positionModifierMultiplier: 2
                                    });
                                }
                                CANADA_POST.bind($container, true);
                                showErrorBox();
                                submitForm($container);
                            } else {
                                $container[0].innerHTML = data;
                                if (typeof bindCheckoutServiceSavedAddresses === "function") {
                                    bindCheckoutServiceSavedAddresses($container);
                                }
                                if (typeof bindAddAddressWithSavedAddresses === "function") {
                                    bindAddAddressWithSavedAddresses($container.closest('.delivery-address--form'), $container);
                                    if (typeof inBuyerPreferences !== undefined) {
                                        refreshAddresses();
                                        formActive.$formRequested = null;
                                        formActive.init();
                                    }
                                }
                            }
                        }
                        TINK.stopProgress($container);
                    },
                    error: function (jqXHR) {
                        if (!TINK.redirectIfConflict(jqXHR)) {
                            $container.find('.accordion-content-target').html(jqXHR);
                            TINK.stopProgress($container);
                            formActive.focusOnSubmit($container);
                        }
                    }
                });
            }

            function refreshAddresses() {
                TINK.sessionAjax({
                    url: buyerPreferencesUrl + '/addressList',
                    success: function (data) {
                        $('#addressListContainer').html(data);
                        $('#cancelAddressChange').click();
                    },
                    error: function (jqXHR) {
                        TINK.redirectIfConflict(jqXHR);
                    }
                });
            }

            function showErrorBox() {
                var errorBox = $('.error-summary');
                if (errorBox.length) {
                    $('html, body').animate({scrollTop: errorBox.offset().top - 75}, 'fast');
                }
            }

            function isFormInError(data) {
                return $(data).filter("form").length > 0;
            }

            function buildFormUrl($container, $trigger) {
                let url = $trigger.data('href');
                let isAddressSelected = $container.find(':radio');
                if (isAddressSelected && isAddressSelected.is(':checked')) {
                    url = TINK.validateUrl(url + '&selected=true');
                }
                return url;
            }

            function addNewAddressIn(containerId, data) {
                let newAddress = `<div class="formActive listaction-element ca--account-address box-solid-medium padding-medium grid-container-medium mb-4" id="${containerId}">${data}	</div>`;
                $('[data-create="new-address"]').before(newAddress);
            }

            return init();
        }
    }
)
(jQuery);

function handleCheckoutButtonState(disableButton) {
    if ($('.checkout-sticky-btn').length) {
        disableButton ? $('.checkout-sticky-btn').find('.checkout-button').addClass('disabled') : $('.checkout-sticky-btn').find('.checkout-button').removeClass('disabled');
    }
}

jQuery(document).ready(function () {
    'use strict';
    $('[data-module~="change-address"]').changeAddress();

    $(document).on('click', '.formActive__cancel', function () {
        if (!$(this).closest("form").hasClass('is_dirty') && isInCheckoutPage()) {
            handleCheckoutButtonState(false);
        }
    });

    $(document).on('click', '#confirm-changes.is_active button.cta-secondary', function () {
        if (isInCheckoutPage()) {
            handleCheckoutButtonState(false);
        }
        $('form.address-form').removeClass('is_dirty');
    });
});
